import { useEffect, useState } from 'react';
import { Flex, Icon, IconButton } from '@chakra-ui/react';
import { useHandleExcelExport } from 'pages/ClusterManagement/hooks/useHandleExport';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import icons from 'shared/icons';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import { TShopClusterViewer } from './ShopClusterContainer';
import useRetailerMultiSelect from 'hooks/useRetailerMultiSelect';

const ShopClusterToolbar = ({ table, selectedRetailers, setSelectedRetailers }: TShopClusterViewer) => {
    const handleExcelExport = useHandleExcelExport();
    const { RetailerMultiSelect, retailerIds } = useRetailerMultiSelect();

    const { setGlobalFilter } = table;
    const ArrowDownIcon = icons.arrowDown;

    const [isLoading, setIsLoading] = useState(false);

    const handleExport = async () => {
        setIsLoading(true);
        await handleExcelExport('shop-cluster', retailerIds);
        setIsLoading(false);
    };

    useEffect(() => {
        setSelectedRetailers(retailerIds);
    }, [retailerIds]);

    return (
        <Flex {...tableToolbarStyle} alignItems="center">
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
            <RetailerMultiSelect />
            <IconButton
                {...iconTableStyle}
                isLoading={isLoading}
                isDisabled={!retailerIds.length}
                onClick={handleExport}
                aria-label="download shop clusters"
                size="sm"
                icon={<Icon as={ArrowDownIcon} />}
                ml={3}
            />
        </Flex>
    );
};

export default ShopClusterToolbar;
